import API_URLS from '../../constants/api-urls';
import fetchAllEntities from '../../utils/fetch-all-entities';

const store = {};

const authorsMaterials: Service = {
    // @ts-ignore
    get: (id: number) => {
        const query = `query {
            materials (
                filter: {author_id: ${id}},
                order_by: {sort: id, order: ASC},
                pagination: {page: 1, limit: 200}
            ) {
                 id,
                 _total
              }
        }`;

        return new Promise((resolve, reject) => {
            if (store[id]) {
                return resolve(store[id]);
            }

            return fetchAllEntities(API_URLS.AUTHORS_MATERIAL_IDS, query, 'materials')
                .then((r) => {
                    const result = r?.data?.materials?.[0]?._total ? r.data.materials : [];

                    store[id] = result.map((material: Material) => material.id);

                    return resolve(store[id]);
                })
                .catch(reject);
        });
    }
};

export default authorsMaterials;
